import { render, staticRenderFns } from "./SegmentacaoConfiguracaoForm.vue?vue&type=template&id=48ccb37a&lazy=true&"
import script from "./SegmentacaoConfiguracaoForm.vue?vue&type=script&lang=js&"
export * from "./SegmentacaoConfiguracaoForm.vue?vue&type=script&lang=js&"
import style0 from "./SegmentacaoConfiguracaoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VContainer,VDatePicker,VMenu,VRow,VTextField})
